export default __webpack_public_path__ + "media/images/elephant-fren_sub-c4caa2db89ca636da6cdedcf37fe9032.png";